import React,{useEffect, useState} from 'react';
import ePlusIcon from '../../../assets/img/event-imgs/e-plus.svg';
import frImage from '../../../assets/img/fundraiser-imgs/fr-img1.png';
import clockIcon from '../../../assets/img/fundraiser-imgs/clock.svg';
import './FundraiserPosts.css'
import { fundraiserPostDatas as fundraiserPostDatasApi } from '../../../api'
import { Link } from 'react-router-dom';

const FundraisersPosts = () => {
    const [ fundriserPostData, setFundriserPostData ] = useState([])
   useEffect( () =>{
    fundraiserPostDatasApi().then( 
        data =>  setFundriserPostData( data)
    )
   }, [])
   console.log( fundriserPostData )
    return (
        <div className='row'>
            {
                fundriserPostData?.map( (item, index) => <div className="col-12 col-lg-6 mb-3" key={index}>
                <Link className="card" style={{backgroundColor: "#171717",borderRadius: "20px",borderStyle: "none", textDecoration:"none"}} to={`/fundraisers/details/${index}`}>
                    <div className="position-relative">
                        <button className="btn btn-primary position-absolute rounded-circle d-flex justify-content-center align-items-center p-1" type="button" style={{backgroundColor: "#00000041",borderStyle: "none",right: "4%",bottom: "4%"}}>
                            <img src={ePlusIcon} alt="" />
                        </button>
                         <img className="w-100" src={frImage} style={{borderRadius: "20px 20px 0px 0px"}} alt="" /> 
                    </div>
                    <div className="card-body">
                        <div className="row gap-2">
                            <div className="col-12">
                                <span className="dating_h">{item.fundersTitle}
                                </span>
                            </div>
                            <div className="col-12">
                                <span className="grp_mem">
                                    {item.fundersDesc}
                                </span>
                            </div>
                            <div className="col-12 d-flex justify-content-between align-items-center">
                                <div>
                                    <span className="grp_mem me-1" style={{color: "#5ED2F1",fontWeight: "500"}}>${item.risersAmount}</span><span className="grp_mem" style={{color: "#5ED2F1"}}>raised</span></div><span className="grp_mem" style={{color: "#5ED2F1"}}>{item.targetStatus}</span>
                            </div>
                            <div className="col-12 d-flex justify-content-between align-items-center">
                                <div className="progress w-100 rounded-pill" style={{height: "13px",backgroundColor: "#ffffff21"}}>
                                    <div className="progress-bar custom-prograse-bar" aria-valuenow="61" aria-valuemin="0" aria-valuemax="100" style={{width: `${item.targetStatus}`}}><span className="visually-hidden">61%</span></div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-start align-items-center gap-1"><img src={clockIcon} alt='' /><span className="e_bdt">{item.leftDay}</span></div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12"><button className="custm-pill-button-small rounded-pill px-3  py-2 post_btn d-flex align-items-center custm-pill-for-contribute rounded-pill w-100" type="button">Contribute</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            )
            }
        </div>
    );
};

export default FundraisersPosts;